import React, { useId } from 'react';

export default function RowVisibilityControls({ rowMode, hideWhenEmpty, onChange }) {
  const hideWhenEmptyId = useId();
  const isDetails = rowMode === 'details';

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 4, width: '100%' }}>
      <div style={{ display: 'inline-flex', gap: 3, alignItems: 'center', flexWrap: 'wrap' }}>
        <button
          type="button"
          className={`btn btn-sm ${!isDetails ? 'btn-primary' : 'btn-outline-secondary'}`}
          onClick={() => onChange({ row_mode: 'always' })}
          title="Show this row in the standard view"
          style={{ fontSize: 10, padding: '2px 8px' }}
        >
          Standard
        </button>
        <button
          type="button"
          className={`btn btn-sm ${isDetails ? 'btn-primary' : 'btn-outline-secondary'}`}
          onClick={() => onChange({ row_mode: 'details' })}
          title="Only show this row in detail mode"
          style={{ fontSize: 10, padding: '2px 8px' }}
        >
          Details
        </button>
      </div>

      <div className="form-check form-switch d-flex align-items-center" style={{ marginBottom: 0, paddingLeft: 0, minHeight: 0 }}>
        <input
          className="form-check-input"
          type="checkbox"
          role="switch"
          id={hideWhenEmptyId}
          checked={!!hideWhenEmpty}
          onChange={(e) => onChange({ hide_when_empty: e.target.checked })}
          style={{ marginLeft: 0, marginTop: 0 }}
        />
        <label className="form-check-label small text-muted ms-2" htmlFor={hideWhenEmptyId}>
          Hide when empty
        </label>
      </div>
    </div>
  );
}